import classNames from 'classnames';
import React from 'react';

import AspectRatio from './AspectRatio';
import BiomeBanner from './BiomeBanner';
import BiomeDescription from './BiomeDescription';
import BiomeInfoPane from './BiomeInfoPane';
import Climatogram from './Climatogram';
import CloseButton from './CloseButton';
import Minimap from './Minimap';
import TabbedContent from './TabbedContent';
import TabbedDisplay from './TabbedDisplay';
import Wildlife from './Wildlife';

const BiomeInfoScreen = ({
    locationInfos,
    isBusy,
    onChangeLeft,
    onChangeRight,
    onClose,
  }) => {

  const contextInfos = locationInfos.map((locationInfo, index) => ({
    locationInfo,
    context: (index === 0 ? 'main' : (index === 1 ? 'compare' : 'unknown')),
  }));

  return (
    <div className="BiomeInfoScreen">

      <AspectRatio styleName="BiomeInfoScreen__header">
        <BiomeBanner
          geocodedName={locationInfos[0].displayName}
          coordinates={locationInfos[0].location.getCoordinateString()}
          biomeName={locationInfos[0].biomeName}
          imageBlob={locationInfos[0].wideBannerImageDef &&
            locationInfos[0].wideBannerImageDef.image}
          onChange={onChangeLeft}
          isBusy={isBusy}
        />
        <div className="BiomeInfoScreen__verticalDivider" />
        <AspectRatio styleName="BiomeInfoScreen__worldMap">
          <Minimap
            locationInfos={locationInfos}
          />
        </AspectRatio>
        {
          locationInfos.length > 1 &&
          <div className="BiomeInfoScreen__verticalDivider" />
        }
        {
          locationInfos.length > 1 &&
          <BiomeBanner
            geocodedName={locationInfos[1].displayName}
            coordinates={locationInfos[1].location.getCoordinateString()}
            biomeName={locationInfos[1].biomeName}
            imageBlob={locationInfos[1].wideBannerImageDef &&
              locationInfos[1].wideBannerImageDef.image}
            onChange={onChangeRight}
            isBusy={isBusy}
          />
        }
      </AspectRatio>

      <TabbedDisplay
        initialIndex={1}
      >
        <TabbedContent title="DESCRIPTION">
          {renderDescription(contextInfos)}
        </TabbedContent>
        <TabbedContent title="CLIMATE">
          {renderClimatogram(contextInfos)}
        </TabbedContent>
        <TabbedContent title="WILDLIFE">
          {renderWildlife(contextInfos)}
        </TabbedContent>
      </TabbedDisplay>

      <CloseButton
        onClick={onClose}
      />
    </div>
  );
};

function infoContainer(contextInfos, jsxGenerator, conditionalCssClasses) {
  return (
    <div className={classNames("BiomeInfoScreen__infoContainer",
                                conditionalCssClasses)}
    >
      {
        contextInfos.reduce((jsxElements, contextInfo) => {
          if (jsxElements.length > 0) {
            jsxElements.push(renderDivider(jsxElements.length));
          }

          jsxElements.push(
            <BiomeInfoPane
              key={`BiomeInfoPane_${jsxElements.length}`}
              locationInfo={contextInfo.locationInfo}>
              {
                jsxGenerator(contextInfo)
              }
            </BiomeInfoPane>
          );

          return jsxElements;
        },
        [])
      }
    </div>
  );
}

function renderDivider(index) {
  return (
    <div
      className="BiomeInfoScreen__verticalFlexDivider"
      key={`biomeInfoScreenDivider_${index}`}/>
  );
}

function renderDescription(contextInfos) {
  return infoContainer(contextInfos,
    contextInfo => (
      <BiomeDescription
        description={contextInfo.locationInfo.description}
        imageDefs={contextInfo.locationInfo.carouselImageDefs}
        compact={contextInfos.length > 1}
      />
    ),
    {
      "BiomeInfoScreen__infoContainer--singleDescription": contextInfos.length === 1,
      "BiomeInfoScreen__infoContainer--compareDescription": contextInfos.length > 1,
    }
  );
}

function renderClimatogram(contextInfos) {
  return infoContainer(contextInfos,
    contextInfo => (
      <Climatogram
        precipData={contextInfo.locationInfo.precipData}
        tempData={contextInfo.locationInfo.tempData}
        compact={false}
        displayHeader={true}
      />
    ),
    {
      "BiomeInfoScreen__infoContainer--singleClimatogram": contextInfos.length === 1,
      "BiomeInfoScreen__infoContainer--compareClimatogram": contextInfos.length > 1,
    }
  );
}

function renderWildlife(contextInfos) {
  return infoContainer(contextInfos,
    contextInfo => (
      <Wildlife
        species={contextInfo.locationInfo.wildlifeInfo.species}
        compact={contextInfos.length > 1}
        wildlifeContext={contextInfo.context}
      />
    ),
    {
      "BiomeInfoScreen__infoContainer--singleWildlife": contextInfos.length === 1,
      "BiomeInfoScreen__infoContainer--compareWildlife": contextInfos.length > 1,
    }
  );
}

export default BiomeInfoScreen;



// WEBPACK FOOTER //
// ./src/components/BiomeInfoScreen.js